import classNames from "classnames";
import { BaseButton } from "../Button/BaseButton.tsx";

export const SelectablePill = ({
  label,
  isSelected,
  onClick,
  size = "sm",
}: {
  label: string;
  isSelected: boolean;
  onClick: () => void;
  size?: "sm" | "md";
}) => (
  <BaseButton
    className={classNames(
      "flex-row-center rounded-full",
      size === "sm" ? "h-600 p-200" : "h-800 px-300 py-200",
      isSelected
        ? "label-md-semibold text-primary"
        : "label-md-default text-secondary hover:text-primary",
      isSelected
        ? "bg-input-surface-active"
        : "bg-input-surface-rest hover:bg-input-surface-hover",
      isSelected
        ? "border-input-border-width-active border-input-border-active"
        : "border-input-border-width border-input-border-rest hover:border-input-border-hover",
    )}
    onClick={onClick}
  >
    {label}
  </BaseButton>
);
